import React from 'react';
import { Link } from 'react-router-dom';

const RelatedBlogCard = ({ blog }) => {
  const { id, image, title, createdAt, tags } = blog || {};

  const tagContent = tags.map((tag, idx) => {
    if (tags.length === idx + 1) return <span key={idx}>#{tag}</span>;
    return <span key={idx}>#{tag}, </span>;
  });

  return (
    <div className="card">
      <Link to={`/blogs/${id}`}>
        <img src={image} className="card-image" alt={title} />
      </Link>
      <div className="p-4">
        <Link
          to={`/blogs/${id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {title}
        </Link>
        <div className="mb-0 tags">{tagContent}</div>
        <p>{createdAt}</p>
      </div>
    </div>
  );
};

export default RelatedBlogCard;
